import _getIterator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/core-js/get-iterator';
import _regeneratorRuntime from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/regenerator';
import _toConsumableArray from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/toConsumableArray';
import _asyncToGenerator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from '~/plugins/Moment.js';
import domain from '~/plugins/domain.js';
import axios from '~/plugins/axios.js';

import UploadFilePanel from '~/components/mainPage/bookModuleSession/UploadFilePanel.vue';
import Loading from '~/components/Loading.vue';

export default {
  name: 'bulkyRegister',
  components: {
    UploadFilePanel: UploadFilePanel,
    Loading: Loading
  },
  data: function data() {
    return {
      isLoading: true,
      exlFile: '',
      workerUserList: null,
      mIsLoading: true,
      // tableBusy: true,
      bulkyRegTableFields: {
        companyName: {
          label: 'Company'
        },
        fullname: {
          label: 'Name'
        },
        // username: {
        //   label: 'User Name'
        // },
        nricFin: {
          label: 'NRIC / FIN'
        },
        workingProfile: {
          label: 'Details'
        },
        uploadFile: {
          label: 'Upload File'
        },
        errorInfo: {
          label: 'Error Info'
        }
      },
      modalInfo: {
        title: '',
        content: {
          fileList: []
        }
      }
    };
  },

  filters: {
    parseDate: function parseDate(dateString) {
      var dateNumber = Number(dateString) * 1000;
      console.log(moment);
      if (!!moment(dateNumber).isValid()) {
        return moment(dateNumber).format('DD-MM-YYYY');
      } else {
        return dateString;
      }
    }
  },
  mounted: function mounted() {},

  methods: {
    printFile: function printFile(fileInput) {
      console.log('\n\n========= exl File ==========\n', this.exlFile, '\n ==========');
      console.log('\n\n========= exl fileInput ==========\n', fileInput.files, '\n ==========');
    },
    bulkyRegister: function bulkyRegister() {
      // this.$store.commit('management/setMisloading')
      console.log('\n\n========= exl File ==========\n', this.exlFile, '\n ==========');
      var _this = this;
      var workerUserList = [];
      var fileReader = new FileReader();

      fileReader.onload = function (ev) {
        var workerUser = []; // 存储获取到的数据
        var data = ev.target.result;
        var workbook = XLSX.read(data, { type: 'binary' }); // 以二进制流方式读取得到整份excel表格对象

        // 表格的表格范围，可用于判断表头是否数量是否正确
        var fromTo = '';
        // 遍历每张表读取
        for (var sheet in workbook.Sheets) {
          if (workbook.Sheets.hasOwnProperty(sheet)) {
            fromTo = workbook.Sheets[sheet]['!ref'];
            console.log(fromTo);
            workerUser = workerUser.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]));
            break; // 如果只取第一张表，就取消注释这行
          }
        }
        // console.log(workerUser);
        _this.workerUserList = workerUser;
        console.log('\n\n ========= _this.workerUserList ========\n', _this.workerUserList, '\n -----------------------');
        _this.$emit('bulkyRegistration', _this.workerUserList);
      };
      fileReader.readAsBinaryString(this.exlFile);
    },


    /*
            * upload file modal panel popup
            * */
    popUpUploadFileModal: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(user, button) {
        var manager, setApplicantInfoReturned;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('\n\n ======== uploadFile() ======= \n', user, '\n ---------------');

                this.modalInfo.title = user.fullname;

                this.$store.commit('setCurrentPendingUploadFileUser', user);

                _context.next = 5;
                return axios.post('/userMsManager/obtainSingleManager', { managerId: 'userMsManager' + user.id });

              case 5:
                manager = _context.sent.data.manager;


                console.log('\n\n ======= uploadFile <|-- manager =======\n', manager, '\n -----------');

                this.modalInfo.content.fileList = [].concat(_toConsumableArray(manager.internalTrainingFiles));

                _context.next = 10;
                return axios.post('/userMsManager/trainingFileUpload/setApplicant', { applicantId: user.id, applicantNricFin: user.nricFin });

              case 10:
                setApplicantInfoReturned = _context.sent.data;


                this.$root.$emit('bv::show::modal', 'modalUploadFile', button);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function popUpUploadFileModal(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return popUpUploadFileModal;
    }(),


    /*
            * upload Training files to corresponding applicant
            * */
    uploadTrainingFiles: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(pdfFileList) {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, pdf;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // console.log('\n\n ========= bulkyRegister <|-- uploadTrainingFiles <|-- pdfFileList ===========\n',
                //     pdfFileList, '\n ---------------');
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 3;
                for (_iterator = _getIterator(pdfFileList); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  pdf = _step.value;

                  this.modalInfo.content.fileList.push(pdf);
                }
                _context2.next = 11;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](3);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 11:
                _context2.prev = 11;
                _context2.prev = 12;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 14:
                _context2.prev = 14;

                if (!_didIteratorError) {
                  _context2.next = 17;
                  break;
                }

                throw _iteratorError;

              case 17:
                return _context2.finish(14);

              case 18:
                return _context2.finish(11);

              case 19:
                console.log('\n\n ========= bulkyRegister <|-- uploadTrainingFiles <|-- pdfFileList ===========\n', pdfFileList, '\n ---------------');

              case 20:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 7, 11, 19], [12,, 14, 18]]);
      }));

      function uploadTrainingFiles(_x3) {
        return _ref2.apply(this, arguments);
      }

      return uploadTrainingFiles;
    }()
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/dashboard/management/bulkyRegister.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/dashboard/management/bulkyRegister.vue
// module chunks = 0 5